import { render, staticRenderFns } from "./NonVehicleCommentViolatorTypeAndEmergency.vue?vue&type=template&id=eab34f74&"
import script from "./NonVehicleCommentViolatorTypeAndEmergency.vue?vue&type=script&lang=ts&"
export * from "./NonVehicleCommentViolatorTypeAndEmergency.vue?vue&type=script&lang=ts&"
import style0 from "./NonVehicleCommentViolatorTypeAndEmergency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports